module.exports = __webpack_public_path__ + "static/media/19.afe19c93.jpg";